import { Col, Row } from "antd";

import { BankingConnections } from "../banking";
import { useFilteredUser } from "@/lib/hooks/useFilteredUser";
import { ContentWrapper } from "@/v1/components/common/styledComponents";
import UserFilters from "@/v1/components/pages/Mandanten/Common/UserFilters";
import { AccountingConnections } from "../documents";
import { Table } from "./styles";

export const IntegrationsView = () => {
  const { user, filterOptions, setFilterOptions } = useFilteredUser();

  return (
    <ContentWrapper style={{ backgroundColor: "rgb(247, 247, 247)" }}>
      <Row>
        <Col flex="auto">
          <UserFilters
            withoutLoadAll
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
          />
        </Col>
      </Row>
      <Table className="mt-4">
        <BankingConnections user={user} />
        <AccountingConnections user={user} />
      </Table>
    </ContentWrapper>
  );
};
